import DeclineModal from "./DeclineModal";

export default DeclineModal;
